import React from "react";

export default function ScoreDial({ score, size = 200, label = "out of 100", testid = "clarity-score-dial" }) {
  const r = size / 2 - 12;
  const c = 2 * Math.PI * r;
  const pct = score == null ? 0 : Math.max(0, Math.min(100, score)) / 100;
  return (
    <div data-testid={testid} className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="var(--exodus-border)" strokeWidth="8" fill="none" />
        <circle
          cx={size / 2} cy={size / 2} r={r} stroke="var(--exodus-gold)" strokeWidth="8" fill="none" strokeLinecap="butt"
          strokeDasharray={c} strokeDashoffset={c * (1 - pct)}
          style={{ transition: "stroke-dashoffset 1400ms cubic-bezier(0.16, 1, 0.3, 1)" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span data-testid={`${testid}-value`} className="font-display gold-text leading-none" style={{ fontSize: size * 0.32 }}>
          {score == null ? "—" : score}
        </span>
        <span className="eyebrow !text-exodus-muted mt-2" style={{ fontSize: Math.max(9, size * 0.045), letterSpacing: "0.15em" }}>{label}</span>
      </div>
    </div>
  );
}
